module.exports = __webpack_public_path__ + "img/bg_buluo_window.84983300.jpg";